import { Slide } from "react-reveal";
import desktop from "../../../assets/images/case-studies/cases/flexipainters/flexi-desktop.PNG";
import tablet from "../../../assets/images/case-studies/cases/flexipainters/flexi-tablet.PNG";
import phone from "../../../assets/images/case-studies/cases/flexipainters/flexi-mobile.png";
import flexilogo from "../../../assets/images/case-studies/cases/flexipainters/flexi-logo.png";
import flexifb from "../../../assets/images/case-studies/cases/flexipainters/flexi-facebook.png";
import flexiig from "../../../assets/images/case-studies/cases/flexipainters/flexi-insta.png";
import flexitik from "../../../assets/images/case-studies/cases/flexipainters/flexi-tiktok.png";
import KCGCaseStudyCard from "../case-study-cards/KCGCaseStudyCard";
import ABCDCaseStudyCard from "../case-study-cards/ABCDCaseStudyCard";
import SdaCaseStudyCard from "../case-study-cards/SdaCaseStudyCard";
import SolutionsNtunaCTAWorld from "../../solutions/SolutionsNtunaCTAWorld";

const FlexiPaintersCaseStudyBody = () => {
  return (
    <section>
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <ul className="case-study-body-items">
              <li className="case-study-item width-600 margin-auto section-spacing-50 no-padding-top">
                <Slide top>
                  <h3 className="case-study-body-section-title ntuna-text-fill">
                    Project Summary
                  </h3>
                </Slide>
                <div className="summary-container">
                  <div className="summary-item">
                    <p className="summary-name">Client</p>
                    <p className="summary-answer">Flexi Painters</p>
                  </div>
                  <div className="summary-item">
                    <p className="summary-name">Industry</p>
                    <p className="summary-answer">
                      Painting & Decoration Services
                    </p>
                  </div>
                  <div className="summary-item">
                    <p className="summary-name">Services</p>
                    <p className="summary-answer">
                      Website design, Logo design, professional social media
                      accounts resetup, Google & Facebook Ads setup, search
                      engine optimization
                    </p>
                  </div>
                  <div className="summary-item">
                    <p className="summary-name">Location</p>
                    <p className="summary-answer">Kampala, Uganda</p>
                  </div>
                  <div className="summary-item">
                    <p className="summary-name">Timeline</p>
                    <p className="summary-answer">4 Weeks</p>
                  </div>
                  <div className="summary-item">
                    <p className="summary-name">Website</p>
                    <p className="summary-answer">
                      <a
                        href="http://flexipainters.com"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        www.FlexiPainters.com
                      </a>
                    </p>
                  </div>
                </div>
              </li>
              <li className="case-study-item width-600 margin-auto section-spacing-50 no-padding-top">
                <Slide top>
                  <h3 className="case-study-body-section-title ntuna-text-fill">
                    Project Overview
                  </h3>
                </Slide>
                <div className="case-study-item-text font-inter-regular">
                  <p>
                    <a
                      href="http://flexipainters.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Flexi Painters
                    </a>
                    , is a leading Uganda's professional painting and decorative
                    finishes company, serving residential, commercial, and
                    institutional clients.
                  </p>
                  <p>
                    While the quality of their workmanship has earned them a
                    strong reputation, their digital presence no longer
                    reflected the professionalism of the business. Their
                    branding, website, online visibility, and social media
                    presence all needed to evolve to support the company's next
                    stage of growth.
                  </p>
                  <p>
                    NTUNA.COM partnered with Flexi Painters to deliver a
                    complete digital transformation that repositioned the
                    company as a modern, more credible, and highly professional
                    brand.
                  </p>
                  <p>
                    Rather than focusing on a single service, this project
                    involved redesigning every major digital touchpoint
                    customers interact with.
                  </p>
                  <p>
                    The objective was to create a consistent and professional
                    brand experience—from the company's visual identity and
                    messaging to its website, search visibility, social media
                    presence, and digital advertising.
                  </p>
                  <p>
                    The result was a unified digital ecosystem that supports
                    marketing, customer acquisition, and long-term business
                    growth.
                  </p>
                </div>
              </li>
              <li className="case-study-item width-800 margin-auto section-spacing-50 no-padding-top">
                <Slide top>
                  <h3 className="case-study-body-section-title ntuna-text-fill">
                    The Challenge
                  </h3>
                </Slide>
                <div className="case-study-item-text font-inter-regular">
                  <p>
                    Although Flexi Painters had built a strong reputation
                    through years of delivering quality painting and decorative
                    finishing services, its digital presence no longer reflected
                    the professionalism, expertise, and scale of the business.
                  </p>
                  <p>
                    The company needed a complete digital transformation that
                    would strengthen its credibility and support future growth.
                  </p>
                  <p>The business faced challenges including:</p>
                  <ul className="case-challenge-list padding-16">
                    <li>
                      <h4>Outdated Brand Identity</h4>
                      <p>
                        The existing logo and visual identity no longer
                        represented the company's professionalism or the premium
                        quality of its services. A stronger, more modern brand
                        was needed to create lasting first impressions and stand
                        out in a competitive market.
                      </p>
                    </li>
                    <li>
                      <h4>Website That Didn't Reflect the Business</h4>
                      <p>
                        The previous website failed to showcase the company's
                        capabilities, and offerings in a compelling way. It
                        lacked the structure, design, and user experience needed
                        to convert visitors into enquiries. It was poor in
                        design and performance.
                      </p>
                    </li>
                    <li>
                      <h4>
                        Inconsistent branding across social media platforms
                      </h4>
                      <p>
                        The company's branding varied across different online
                        platforms, resulting in an inconsistent customer
                        experience. There was a need to unify every digital
                        touchpoint under one professional and recognizable brand
                        identity.
                      </p>
                    </li>
                    <li>
                      <h4>Limited visibility on search engines.</h4>
                      <p>
                        Potential customers searching online for painting and
                        decorative finishing services had limited opportunities
                        to discover the business. The website required a solid
                        SEO foundation to improve long-term visibility in search
                        engines.
                      </p>
                    </li>
                    <li>
                      <h4>No Structured Digital Advertising</h4>
                      <p>
                        The business was missing a strategic digital advertising
                        setup to consistently reach potential customers. Proper
                        Facebook, Google, and YouTube advertising infrastructure
                        was needed to increase visibility, generate qualified
                        leads, and support business growth.
                      </p>
                    </li>
                  </ul>
                </div>
              </li>
              <li className="case-study-item width-600 margin-auto section-spacing-50 no-padding-top">
                <Slide top>
                  <h3 className="case-study-body-section-title ntuna-text-fill">
                    The Solution
                  </h3>
                </Slide>
                <div className="case-study-item-text font-inter-regular">
                  <p>
                    NTUNA.COM delivered a comprehensive digital transformation
                    designed to strengthen the Flexi Painter's brand, improve
                    visibility, and create a solid foundation for sustainable
                    growth.
                  </p>

                  <ul className="case-challenge-list padding-16">
                    <li>
                      <h4>
                        <span className="ntuna-coral">✔︎ </span> World-Class
                        Brand Identity Redesign
                      </h4>
                      <p>
                        We completely redesigned the Flexi Painters logo to
                        better represent the professionalism, quality, and
                        modern direction of the company.
                      </p>
                      <div className="case-study-images-container section-spacing-24">
                        <figure>
                          <img src={flexilogo} alt="Flexi Painters new logo" />
                          <figcaption>Flexi Painters new logo</figcaption>
                        </figure>
                      </div>
                      <p>
                        Our work included: Professional logo redesign, Modern
                        visual identity, Brand colour refinement, Typography
                        selection, Consistent brand presentation guidelines
                      </p>
                      <p className="boldTitle ntuna-dark section-spacing-30 no-padding-bottom">
                        Outcome
                      </p>
                      <p>
                        Flexi Painters now has a premium visual identity that
                        creates a strong first impression and reflects the
                        quality of its workmanship.
                      </p>
                    </li>
                    <li>
                      <h4>
                        <span className="ntuna-coral">✔︎ </span> World-Class
                        Website Design & Development
                      </h4>
                      <p>
                        We designed and developed a modern, high-performance
                        website that showcases the company's expertise while
                        making it easy for visitors to explore services and
                        request quotations.
                      </p>
                      <Slide top>
                        <div className="case-study-images-container section-spacing-24">
                          <figure>
                            <img
                              src={tablet}
                              alt="Flexi Painters website tablet view"
                            />
                            <figcaption>
                              Flexi Painters website tablet view
                            </figcaption>
                          </figure>
                          <figure>
                            <img
                              src={phone}
                              alt="Flexi Painters website mobile phone view"
                            />
                            <figcaption>
                              Flexi Painters website mobile phone view
                            </figcaption>
                          </figure>
                          <figure className="case-big-img">
                            <img
                              src={desktop}
                              alt="Flexi Painters website desktop view"
                            />
                            <figcaption>
                              Flexi Painters website desktop view
                            </figcaption>
                          </figure>
                        </div>
                      </Slide>

                      <p>
                        Features included: Modern UI/UX design,
                        Mobile-responsive development, Service pages, Portfolio
                        showcase, Project galleries, Contact and quotation
                        forms, Performance optimisation, SEO-friendly
                        architecture, etc.
                      </p>
                      <p className="boldTitle ntuna-dark section-spacing-30 no-padding-bottom">
                        Outcome
                      </p>
                      <p>
                        The website now serves as the company's primary digital
                        sales and credibility platform.
                      </p>
                    </li>

                    <li>
                      <h4>
                        <span className="ntuna-coral">✔︎ </span>Professional
                        Social Media Reset
                      </h4>
                      <p>
                        We professionally redesigned and aligned the company's
                        presence across all major social media platforms.
                      </p>
                      <p>
                        Platforms included: Facebook, Instagram, TikTok and
                        YouTube
                      </p>
                      <Slide top>
                        <div className="case-study-images-container section-spacing-24">
                          <figure>
                            <img
                              src={flexifb}
                              alt="Flexi Painters facebook page"
                            />
                            <figcaption>
                              Flexi Painters Facebook page
                            </figcaption>
                          </figure>
                          <figure>
                            <img
                              src={flexiig}
                              alt="Flexi Painters Instagram page"
                            />
                            <figcaption>
                              Flexi Painters Instagram page
                            </figcaption>
                          </figure>
                          <figure className="case-big-img">
                            <img
                              src={flexitik}
                              alt="Flexi Painters Tiktok page"
                            />
                            <figcaption>Flexi Painters Tiktok page</figcaption>
                          </figure>
                        </div>
                      </Slide>
                      <p>
                        Our work included: Profile optimisation, Branded cover
                        designs, Consistent visual identity, Professional
                        profile setup and Unified brand messaging.
                      </p>
                      <p className="boldTitle ntuna-dark section-spacing-30 no-padding-bottom">
                        Outcome
                      </p>
                      <p>
                        Every customer interaction across social media now
                        reflects one consistent, professional, and trustworthy
                        brand.
                      </p>
                    </li>
                    <li>
                      <h4>
                        <span className="ntuna-coral">✔︎ </span>Search Engine
                        Optimization (SEO)
                      </h4>
                      <p>
                        To improve long-term discoverability, we implemented a
                        comprehensive SEO foundation across the website.
                      </p>
                      <p>
                        This included: Keyword optimisation, Technical SEO,
                        Metadata optimisation, Internal linking, Search-friendly
                        page structure and Performance improvements
                      </p>
                      <p className="boldTitle ntuna-dark section-spacing-30 no-padding-bottom">
                        Outcome
                      </p>
                      <p>
                        The business is better positioned to appear in search
                        results when potential customers look for professional
                        painting services.
                      </p>
                    </li>

                    <li>
                      <h4>
                        <span className="ntuna-coral">✔︎ </span>Digital
                        Advertising Setup
                      </h4>
                      <p>
                        To accelerate visibility and lead generation, we
                        established advertising foundations across major digital
                        platforms and setup their Facebook, Google and Youtube
                        ads to run for a year.
                      </p>
                      <p>
                        This included: Facebook Ads (Campaign setup, Audience
                        targeting, Conversion-focused advertising), Google Ads (
                        Search campaign setup, Keyword targeting, Local lead
                        generation), YouTube Ads (Brand awareness campaigns,
                        Video advertising setup, Audience targeting)
                      </p>
                      <p className="boldTitle ntuna-dark section-spacing-30 no-padding-bottom">
                        Outcome
                      </p>
                      <p>
                        Flexi Painters now has the infrastructure to
                        consistently reach new audiences, increase brand
                        awareness, and generate qualified enquiries through paid
                        digital marketing.
                      </p>
                    </li>
                    <li>
                      <h4>
                        <span className="ntuna-coral">✔︎ </span>Team Training &
                        Handover
                      </h4>
                      <p>
                        Beyond implementation, we provided a hands-on training
                        to equip the Flexi Painters team with the knowledge,
                        confidence and strategies to manage their system
                        effectively — ensuring long term independence and smooth
                        day-to-day operations.
                      </p>
                    </li>
                  </ul>
                </div>
              </li>
              <li className="case-study-item width-600 margin-auto section-spacing-50 no-padding-top">
                <Slide top>
                  <h3 className="case-study-body-section-title ntuna-text-fill">
                    Results & Impact
                  </h3>
                </Slide>
                <div className="case-study-item-text font-inter-regular">
                  <p>
                    The project successfully transformed Flexi Painters' digital
                    presence into a professional business asset.
                  </p>
                  <p>Key outcomes included:</p>
                  <ul className="inner-list">
                    <li>
                      <span>A world-class brand identity.</span>
                    </li>
                    <li>
                      <span>A modern, high-performance website..</span>
                    </li>
                    <li>
                      <span>
                        Consistent branding across all major digital platforms.
                      </span>
                    </li>
                    <li>
                      <span>Improved online visibility through SEO.</span>
                    </li>
                    <li>
                      <span>Professional social media presence.</span>
                    </li>
                    <li>
                      <span>
                        Digital advertising infrastructure ready for customer
                        acquisition.
                      </span>
                    </li>
                    <li>
                      <span>Stronger customer confidence and credibility.</span>
                    </li>
                    <li>
                      <span>
                        A scalable digital foundation for future marketing and
                        growth.
                      </span>
                    </li>
                  </ul>
                  <p>
                    Today, Flexi Painters presents itself online with the same
                    level of professionalism and quality that customers
                    experience on every project.
                  </p>
                </div>
              </li>

              <li className="case-study-item width-600 margin-auto section-spacing-50 no-padding-top">
                <Slide top>
                  <h3 className="case-study-body-section-title ntuna-text-fill">
                    What the Client Said
                  </h3>
                </Slide>
                <div className="case-study-item-text font-inter-regular">
                  <blockquote>
                    <p>
                      "NTUNA.COM didn't just redesign our website—they
                      transformed how our business is presented online. From our
                      new logo and website to our social media platforms, SEO,
                      and digital advertising setup, every part of our brand now
                      looks professional and consistent. The entire process was
                      well organised, and the final result has given us a
                      digital presence we're proud to share with our clients. We
                      now have the confidence that our online presence truly
                      reflects the quality of our work."
                    </p>
                    <p className="boldTitle right-align">
                      — Mr. Mukasa Alex, CEO & Founder, Flexi Painters
                    </p>
                  </blockquote>
                </div>
              </li>
            </ul>
            <SolutionsNtunaCTAWorld />
            <ul>
              <li className="case-study-item section-spacing-50 no-padding-top">
                <Slide top>
                  <h3 className="case-study-body-section-title ntuna-text-fill">
                    Related Case Studies
                  </h3>
                </Slide>
                <ul className="case-studies-container">
                  <KCGCaseStudyCard />
                  <ABCDCaseStudyCard />
                  <SdaCaseStudyCard />
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FlexiPaintersCaseStudyBody;
